import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { g as getIcon } from "../../Icon.js";
const EmoticonAnnoyed = ({ size, isHovered }) => {
  const normal = /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { d: "M24.85 4.56A19.65 19.65 0 1 0 44.5 24.21 19.68 19.68 0 0 0 24.85 4.56Zm0 38A18.35 18.35 0 1 1 43.2 24.21a18.37 18.37 0 0 1-18.35 18.35Z" }),
    /* @__PURE__ */ jsx("path", { d: "M24.85 27.47c-5.94 0-10.09 3-11.12 6a.652.652 0 0 0 .4.83.81.81 0 0 0 .22 0 .64.64 0 0 0 .61-.44c.86-2.47 4.61-5.1 9.89-5.1s9.16 2.58 9.88 5.07a.652.652 0 1 0 1.25-.37c-.85-2.9-5.03-5.99-11.13-5.99Zm3.08-7.77c.07.01.14.01.21 0l.67-.23c-.005.08-.005.16 0 .24a1.592 1.592 0 0 0 2.714 1.125 1.592 1.592 0 0 0-.014-2.265l2.39-.8a.651.651 0 0 0 .41-.82.66.66 0 0 0-.83-.41l-5.74 1.93a.651.651 0 0 0 .21 1.26l-.02-.03Zm-12.1-2 2.38.8a1.591 1.591 0 0 0 1.988 2.464 1.59 1.59 0 0 0 .712-1.323c.005-.08.005-.16 0-.24l.68.23h.2a.65.65 0 0 0 .21-1.26l-5.74-1.93a.65.65 0 0 0-.41 1.23l-.02.03Z" })
  ] });
  const normalHover = /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M16.057 16.195a.65.65 0 0 0-.414 1.232l3.914 1.314-3.914 1.314a.65.65 0 0 0 .414 1.232l5.732-1.924a.649.649 0 0 0 0-1.244l-5.732-1.924Zm17.64 1.232a.65.65 0 1 0-.414-1.232l-5.722 1.924a.65.65 0 0 0 0 1.244l5.722 1.924a.65.65 0 0 0 .414-1.232L29.79 18.74l3.907-1.314Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M24.82 4.35A19.65 19.65 0 1 0 44.47 24 19.67 19.67 0 0 0 24.82 4.35Zm0 38A18.35 18.35 0 1 1 43.17 24a18.37 18.37 0 0 1-18.35 18.35Z" }),
    /* @__PURE__ */ jsx("path", { d: "M24.82 27.26c-5.94 0-10.09 3-11.12 6a.682.682 0 0 0 .09.59.65.65 0 0 0 .53.27h21a.64.64 0 0 0 .62-.83c-.83-2.94-5.02-6.03-11.12-6.03Zm-9.47 5.53c1.33-2.18 4.81-4.23 9.47-4.23 4.66 0 8.28 2 9.53 4.23h-19Z" })
  ] });
  return getIcon({ size, isHovered, normal, normalHover });
};
export {
  EmoticonAnnoyed as default
};
//# sourceMappingURL=EmoticonAnnoyed.js.map
